import { makeAsyncMethodsActions, makeAsyncMethodsCreator, customActions } from "./common";

export const EKYC_SESSION = makeAsyncMethodsActions("ekyc/SESSION");
export const ekycSession = makeAsyncMethodsCreator(EKYC_SESSION);

export const EKYC_RESULT = makeAsyncMethodsActions("ekyc/RESULT");
export const ekycResult = makeAsyncMethodsCreator(EKYC_RESULT);

// 법인 유형 선택 — API 없이 Redux 상태만 업데이트
export const EKYC_SET_CORP_AUTH_TYPE = "ekyc/SET_CORP_AUTH_TYPE";

export const EKYC_DELEGATE = makeAsyncMethodsActions("ekyc/DELEGATE");
export const ekycDelegate = makeAsyncMethodsCreator(EKYC_DELEGATE);

export const EKYC_RESET = makeAsyncMethodsActions("ekyc/RESET");
export const ekycReset = makeAsyncMethodsCreator(EKYC_RESET);

// 승계 계약 구분값 저장 (EkycComplete 랜딩 경로 분기용)
// "A": 인수인 → /successor/afterinfo
// "B": 승계인 → /successor/contractInfo
// "":  일반    → /auth/contractInfo
export const EKYC_SET_SUCCESSOR = "ekyc/SET_SUCCESSOR";

const initialState = {
    // UseB 세션
    transactionId: "",
    accessToken: "",

    // 인증 결과 (postMessage 수신)
    result: "",             // "success" | "failed" | "complete" | "close" | ""
    resultType: 0,          // 1: 자동승인, 2: 자동거부, 5: 심사대기
    reviewResult: null,

    // 법인 전용
    corpAuthType: "",       // "representative" | "delegate"
    delegationData: null,

    // 승계 계약 구분 (SuccessorUser에서 설정)
    successorGubun: "",     // "A" | "B" | ""

    isFetching: false,
    errorCode: "",
    fieldLabel: "",
    errorMessage: "",
};

const Reducer = customActions(
    {
        [EKYC_SESSION.POST.REQUEST]: (state) => {
            return Object.assign({}, state, {
                isFetching: true,
                errorCode: "",
                fieldLabel: "",
                errorMessage: "",
            });
        },
        [EKYC_SESSION.POST.SUCCESS]: (state, action) => {
            return Object.assign({}, state, {
                isFetching: false,
                transactionId: action.payload?.transaction_id || "",
                accessToken: action.payload?.access_token || "",
            });
        },
        [EKYC_SESSION.POST.FAIL]: (state, action) => {
            return Object.assign({}, state, {
                isFetching: false,
                errorCode: action.payload?.errorCode || "SESSION_FAIL",
                fieldLabel: action.payload?.fieldLabel || "",
            });
        },

        [EKYC_RESULT.POST.REQUEST]: (state) => {
            return Object.assign({}, state, { isFetching: true });
        },
        [EKYC_RESULT.POST.SUCCESS]: (state, action) => {
            return Object.assign({}, state, {
                isFetching: false,
                resultType: action.payload?.resultType || 0,
                // reviewResult는 success 시에만 설정, 이후 complete/failed/close 호출로 덮어쓰지 않음
                reviewResult: action.payload?.reviewResult !== undefined
                    ? action.payload.reviewResult
                    : state.reviewResult,
            });
        },
        [EKYC_RESULT.POST.FAIL]: (state) => {
            return Object.assign({}, state, {
                isFetching: false,
                errorCode: "RESULT_FAIL",
            });
        },

        [EKYC_SET_CORP_AUTH_TYPE]: (state, action) => {
            return Object.assign({}, state, {
                corpAuthType: action.payload || "",
            });
        },

        [EKYC_DELEGATE.GET.REQUEST]: (state) => {
            return Object.assign({}, state, {
                isFetching: true,
                errorCode: "",
            });
        },
        [EKYC_DELEGATE.GET.SUCCESS]: (state, action) => {
            return Object.assign({}, state, {
                isFetching: false,
                delegationData: action.payload || null,
            });
        },
        [EKYC_DELEGATE.GET.FAIL]: (state) => {
            return Object.assign({}, state, {
                isFetching: false,
                errorCode: "DELEGATE_FAIL",
            });
        },

        [EKYC_SET_SUCCESSOR]: (state, action) => {
            return Object.assign({}, state, {
                successorGubun: action.payload || "",
            });
        },

        [EKYC_RESET.POST.REQUEST]: (state) => {
            return Object.assign({}, initialState);
        },
    },
    initialState,
    [
        "ekyc/SESSION",
        "ekyc/RESULT",
        "ekyc/DELEGATE",
        "ekyc/RESET",
    ]
);

export default Reducer;
